import useSnackBar from "@/hooks/useSnackBar";
import CloseIcon from "@/icons/CloseIcon";

function SnackBar() {
	const { snackBarMessage, snackBarOpen, setSnackBarOpen, showMeButton } = useSnackBar();

	return (
		<div role="alert" className={`snackbar ${snackBarOpen ? "open" : ""}`}>
			<div className="snackbar-content">
				<div className="snackbar-message">
					<p>{snackBarMessage}</p>

					{showMeButton ? (
						<a className="btn-sm btn-white-outline" href="/wish-list">
							Show Me
						</a>
					) : null}
				</div>

				<button aria-label="Close" className="btn-close btn-reset" onClick={() => setSnackBarOpen(false)}>
					<CloseIcon />
				</button>
			</div>
		</div>
	);
}
export default SnackBar;